module.exports = __webpack_public_path__ + "img/environmentalMonitoring03.e35cba11.png";